import type { PersistedState } from '@/types/persistence';
import { STORAGE_QUOTA_BYTES } from '@/types/persistence';

/**
 * Estimate the serialized size of a state object (P1.4.2).
 */
export function estimateSize(state: PersistedState): number {
  try {
    return new Blob([JSON.stringify(state)]).size;
  } catch {
    return JSON.stringify(state).length;
  }
}

/**
 * Check storage quota. Warns at 80% of ~5 MB; blocks writes at 100%.
 */
export function checkQuota(state: PersistedState): {
  used: number;
  quota: number;
  percent: number;
  nearLimit: boolean;
  atLimit: boolean;
} {
  const used = estimateSize(state);
  const quota = STORAGE_QUOTA_BYTES;
  const percent = (used / quota) * 100;
  return {
    used,
    quota,
    percent,
    nearLimit: percent >= 80,
    atLimit: percent >= 100,
  };
}
